import { makeStyles, Typography } from "@material-ui/core"
import clsx from "clsx"
import React, { FC } from "react"
import { useSetRecoilState } from "recoil"
import { useNavigation } from "../../hooks/useNavigation"
import { loggingOutState } from "../../utils/store"
import { colors } from "../../utils/theme"
import { GhostButton } from "../atoms/button/Button"
import Logo from "../atoms/Logo"
import { TitledCard } from "../molecules/titledCard/TitledCard"
import { BaseTemplate } from "../templates/BaseTemplate"

const useStyles = makeStyles((theme) => ({
  logo: {
    position: "absolute",
    top: theme.spacing(6),
    left: theme.spacing(6),
  },
  button: {
    width: "100%",
  },
  center: {
    display: "flex",
    alignItems: "center",
  },
  denim: {
    color: colors.neutral.denim,
  },
  returnTo: {
    color: colors.neutral.asphalt,
    marginRight: 4,
  },
  marginBottom32: {
    marginBottom: theme.spacing(4),
  },
}))

const LoggedOut: FC = () => {
  const classes = useStyles()
  const { toLogin } = useNavigation()
  const setLoggingOut = useSetRecoilState(loggingOutState)

  return (
    <BaseTemplate>
      <Logo className={classes.logo} />
      <TitledCard title="Logged Out">
        <Typography
          variant="body1"
          className={clsx(classes.marginBottom32, classes.denim)}
        >
          You have logged out of your account. Thank you for using Vira Pro!
        </Typography>
        <div className={classes.center}>
          <div>
            <Typography variant="h6" className={classes.returnTo}>
              Return to
            </Typography>
          </div>
          <GhostButton
            onClick={() => {
              setLoggingOut(false)
              const timeout = setTimeout(() => {
                toLogin()
                clearTimeout(timeout)
              }, 100)
            }}
          >
            Log In
          </GhostButton>
        </div>
      </TitledCard>
    </BaseTemplate>
  )
}

export default LoggedOut
